"use client";

import { FormattedMessage } from "react-intl";
import { useLocale } from "@/app/providers/IntlProvider";
import { FORMAT_TAGS, FORMAT_TAG_META, type FormatTag } from "./format-tags";
import { canonicalTag, topicLabel } from "./topic-tags";

/**
 * Visible name of an article tag: a format tag (tutorial, case study…) through its
 * translation key, a topic tag through its readable label. Never shows a raw slug.
 *
 * @param tag - Tag slug from the article front matter.
 */
export function TagLabel({ tag }: { tag: string }) {
  const { locale } = useLocale();
  const slug = canonicalTag(tag);
  if ((FORMAT_TAGS as readonly string[]).includes(slug)) {
    return <FormattedMessage id={FORMAT_TAG_META[slug as FormatTag].labelKey} />;
  }
  return <>{topicLabel(slug, locale)}</>;
}
